import React from 'react';
import { Tag, Text } from 'src/@vymo/ui/atoms';
import { format as formatDate } from 'date-fns';

export const getCellView = (value, input) => {
  let dateFormat = input?.format;
  if (!value) return <Text>-</Text>;
  switch (input?.type) {
    case 'date':
      dateFormat = dateFormat || 'dd MMM yyyy';
      return <Text>{formatDate(value, dateFormat)}</Text>;
    case 'date_range_v2':
      dateFormat = dateFormat || 'MMMM d, yyyy h:mm aa';
      return <Text>{formatDate(value, dateFormat)}</Text>;
    case 'code_name_spinner':
    case 'multi_select_auto_complete':
      return <Tag label={value} />;
    case 'text':
    default:
      return <Text>{value}</Text>;
  }
};
